import React, { FC } from 'react';
import styles from './styles.module.scss';
import { Typography } from '@material-ui/core';
import { getStarRating } from '../../utils/helpers';
import { StarRating } from '../StarRating';
import { useTranslation } from 'react-i18next';
import { AggregateRating } from '../../models/app';

interface ComponentProps {
  aggregateRating: AggregateRating;
  reviewCount?: number;
}

const BigAggregateRatingWithStars: FC<ComponentProps> = ({aggregateRating, reviewCount}) => {
  const { t } = useTranslation();
  reviewCount = reviewCount || aggregateRating.reviewCount;
  return (
    <div className={styles.ratingScore}>
      <Typography variant='h3' component='p' data-testid="bigAggregateRatingWithStars">
        {getStarRating(aggregateRating)}
      </Typography>
      <div className={styles.ratings}>
        <StarRating rating={aggregateRating} size={'small'} />
        <Typography>
          {t('app_details.number_of_reviews', { count: reviewCount })}
        </Typography>
      </div>
    </div>
  );
};

export default BigAggregateRatingWithStars;
